export const baseState = {
    executives: [],
    currentExecutive: {},
    estates: [],
    houses: [],
    sliders: [],
    currentHouse: {},
    subscribeResponse: '',
    subscribeStatus: false,
    privacyContent: '',
    siteData: {},
    articles: [],
    currentArticle: {},
    loadingState: true
}